/* eslint-disable */
import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import scrollEventFn from '../scroll_event'
import 'swiper/css'
import 'swiper/css/pagination'
export default function Home(props){
  let navigate = useNavigate()
  let [contentList, setContentList] = useState([])
  let [contentNum, setContentNum] = useState(0)
  useEffect(() => {
    // 공지사항 4개 가져오기
    let arr = []
    for(let i=0; i<4; i++){
      arr.push(props.noticeList[i])
    }
    setContentList(arr)
    // 페이지 진입 애니메이션
    let mainBannerIcon = document.querySelector('.mainBannerIcon')
    let mainBannerTxt = document.querySelectorAll('.mainBannerTxt')
    let mainBannerSlide = document.querySelector('.mainBannerSlide')
    setTimeout(() => {
      mainBannerIcon.classList.add('on')
      mainBannerSlide.classList.add('on')
      for(let i=0; i<mainBannerTxt.length; i++){
        mainBannerTxt[i].classList.add('on')
      }
    }, 100)
  }, [])
  // scroll event
  const scroll01 = useRef(null)
  const scroll02 = useRef(null)
  const scrollArr = [
    scroll01,
    scroll02,
  ]
  useEffect(() => {
    window.scrollTo({top : 0, behavior : 'smooth'})
    // scroll event
    scrollEventFn(scrollArr)
    window.addEventListener("scroll", () => {scrollEventFn(scrollArr)})
    return () => {
      window.removeEventListener("scroll", () => {scrollEventFn(scrollArr)})
    }
  }, [])
  // html
  return(
    <>
      {/* 1 */}
      <div className="mainBannerWrap">
        <div className="mainGrayArea"></div>
        <div className="mainBannerIcon">
          <img src="/img/main_banner_icon.png" alt="main banner icon"/>
        </div>
        <div className="mainBannerTxtBox">
          <div className="mainBannerTxtInner">
            <div className="mainBannerTxt mainBannerTxt01">
              업무 전문가와 IT의 융합,<br/>손해사정업무 프로세스 혁신기업
            </div>
            <br/>
            <div className="mainBannerTxt mainBannerTxt02">
              DX손해사정법인은 IT솔루션을 기반으로 보험금 심사 및<br/>지급업무의 정확성과 효율성을 높인 국내 최고의 손해사정회사입니다.
            </div>
          </div>
        </div>
        <div className="mainBannerSlide">
          <Swiper
            direction={'vertical'}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[Autoplay, Pagination]}
            className="mySwiper"
            style={{height:'100%'}}
          >
            <SwiperSlide className="mainBannerImg" style={{backgroundImage:'url(/img/main_banner_01.png)'}}></SwiperSlide>
            <SwiperSlide className="mainBannerImg" style={{backgroundImage:'url(/img/main_banner_02.png)'}}></SwiperSlide>
          </Swiper>
        </div>
      </div>
      {/* 2 */}
      <div className="mainConWrap">
        <div className="mainGrayArea"></div>
        <div className="mainConTitle scrollBox" ref={scroll01}>㈜DX손해사정법인 NEWS</div>
        <div className="mainConBox scrollBox" ref={scroll02}>
          <div className="mainConOne mainConImg">
            <div className="mainConImgBox">
              {
                contentList && contentList.map((a, i) => (
                  <button
                    key={i}
                    className={`mainConImgOne ${contentNum == i ? 'on' : ''}`}
                    style={a.src ? {backgroundImage:`url(${a.src})`} : {}}
                    onClick={() => {setContentNum(i)}}
                  >
                    <img src="/img/target.png" className="targetImg" alt=""/>
                  </button>
                ))
              }
            </div>
          </div>
          <div className="mainConOne mainConTxt">
            <div className="mainConTxtTop">
              <div className="mainConTxtCLSFC">{contentList[contentNum]?.classification}</div>
              <div className="mainConTxtDate">{contentList[contentNum]?.date}</div>
            </div>
            <br/>
            {contentList[contentNum]?.title}<br/><br/>
            <div className="mainConScript" dangerouslySetInnerHTML={{__html : contentList[contentNum]?.content}}></div>
            <br/>
            <button className="mainConBtn" onClick={() => {navigate('/company/notice')}}>더보기 →</button>
          </div>
        </div>
      </div>
    </>
  )
}